import { render } from "./MyStories.vue?vue&type=template&id=b59fdcc2"
import script from "./MyStories.vue?vue&type=script&lang=js"
export * from "./MyStories.vue?vue&type=script&lang=js"

import exportComponent from "D:\\javascript\\storyticket-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__